import React from 'react';

import { LoginByEmailFormStepper } from './LoginByEmailFormStepper';
import { LoginByPhoneFormStepper } from './LoginByPhoneFormStepper';

// TODO - Determine what stepper to render (LoginByEmailFormStepper or LoginByPhoneFormStepper)
// TODO - Remove WagLoginForm folder after integration
// TODO - Remove unused files (this can be a global change)

type WagLoginFormProps = {
  formStepperName: string;
  onComplete?: Function;
};

const formMapping = {
  [LoginByEmailFormStepper.name]: props => (
    <LoginByEmailFormStepper
      {...props}
    />
  ),
  [LoginByPhoneFormStepper.name]: props => (
    <LoginByPhoneFormStepper
      {...props}
    />
  ),
};

export const WagLoginForm = (props: WagLoginFormProps) => {
  const Component = formMapping[props.formStepperName] || formMapping[LoginByEmailFormStepper.name];
  return (
    <>
      <Component
        {...props}
      />
    </>
  );
};
